import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient, trpc, trpcClient } from '@/lib/trpc';
import { AstroPetTRPCProvider } from '@/lib/trpcContext';

export function AstroPetInternalTRPCProvider({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <AstroPetTRPCProvider value={{ trpc, trpcClient }}>
        {children}
      </AstroPetTRPCProvider>
    </QueryClientProvider>
  );
}

export { queryClient };
